import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import router from './router/index'
import VueSweetalert2 from 'vue-sweetalert2';
import CKEditor from "@ckeditor/ckeditor5-vue";
import { createPinia, PiniaVuePlugin } from 'pinia'

// Plugins
import './plugins/vue2-touch-events'
import './plugins/axios-config'
import './plugins/sweetalert2'
import './plugins/vue-youtube'
// Fim de Plugins

import "@/design/index.scss";

import store from '@/state/store'

import App from './App.vue'

import i18n from './i18n'

import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.snow.css'

Vue.use(VueQuillEditor)
Vue.use(CKEditor)
Vue.use(VueRouter)
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(PiniaVuePlugin)
const pinia = createPinia()

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(VueSweetalert2);
Vue.component('apexchart', VueApexCharts)

require('@/state/subscriber')

store.dispatch('window/changeWindowWidth', window.innerWidth)
window.addEventListener("resize", () => {
  store.dispatch('window/changeWindowWidth', window.innerWidth)
})
store.dispatch('sessao/updateSessaoFromLocalStorage')
store.dispatch('etotemlayout/updateEtotemLayoutFromLocalStorage')

const multiTokens = localStorage.getItem('multiTokens')
if (multiTokens && JSON.parse(multiTokens).length) {
  store.dispatch('atendimento/changeMultiAtendimentoSplash', true)
  store.dispatch('multiauth/getUserInfo', JSON.parse(multiTokens)).then(() => {
    new Vue({
      router,
      store,
      pinia,
      i18n,
      render: h => h(App)
    }).$mount("#app");
  })
} else {
  store.dispatch('auth/updateAuthFromLocalStorage')
  store.dispatch('auth/getUserInfo', localStorage.getItem('token')).then(() => {
    new Vue({
      router,
      store,
      pinia,
      i18n,
      render: h => h(App)
    }).$mount("#app");
  })
}


